
import React, { useState, useEffect, useContext } from 'react';
import './AddGardenerForm.css';
import './Buttons.css';
import api from '../api';
import { subscribeUserToPush } from './utils';
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;


const GardenerOnboard = ({
    handleUpdateGardener,
    handleAddPlant,
    handleTabChange,
    currentDate,
    deferredPrompt,
    setDeferredPrompt
}) => {
    const [gardener, setGardener] = useState({
        name: '',
        email: '',
        phone: '',
        locationID: '',
        familysize: '',
        experienceLevel: '',
        isNewUser: 1,
        city: '',
        province: '',
        country: '',
        plantID: '',
        plantType: '',
        userid: ''
    });
    const [plants, setPlants] = useState([]);
    const [locations, setLocations] = useState([]);
    const [currentGardener, setCurrentGardener] = useState(null);
    const [userPlants, setUserPlants] = useState([]);
    const [step, setStep] = useState(1);
    const [progressCount, setProgressCount] = useState(0);
    const [hasAddedPlant, setHasAddedPlant] = useState(false);
    const [wantsSeasonalAdvice, setWantsSeasonalAdvice] = useState(null);
    const [wantsInstall, setWantsInstall] = useState(null);
    const [selectedPlantIDs, setSelectedPlantIDs] = useState([]);
    const [emailError, setEmailError] = useState("");
    const [isVerifyingEmail, setIsVerifyingEmail] = useState(false);
    const [verificationCode, setVerificationCode] = useState("");
    const [verificationError, setVerificationError] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");
    const [hasFinishedLoading, setHasFinishedLoading] = useState(false);
    const [isRequestingPermission, setIsRequestingPermission] = useState(false);
    const [userInstallChoice, setUserInstallChoice] = useState(null);
    // "accepted" | "declined" | null

    const [browserInstallOutcome, setBrowserInstallOutcome] = useState(null);
    // "accepted" | "dismissed" | null

    const handleLocationChange = (e) => {
        console.log("ComboBox value selected:", e.target.value); // Log the value selected from combo box
        console.log("locations array", locations);
        const selectedLocation = locations.find((location) => location.id.toString() === e.target.value);

        console.log("Selected location ID:", e.target.value); // Debug statement for selected location ID
        console.log("Selected location object:", selectedLocation); // Debug statement for selected location object

        if (selectedLocation) {
            const updatedGardener = {
                ...gardener,
                locationID: e.target.value,
                city: selectedLocation.city,
                province: selectedLocation.province,
                country: selectedLocation.country
            };

            setGardener(updatedGardener);
        } else {
            console.log("No valid location selected."); // Debug statement for invalid selection
        }
    };

    const initialTotalSteps = () => {
        let steps = 6; // base
        if (deferredPrompt) steps += 1;
        if (typeof Notification !== 'undefined' && Notification.permission === 'default')
            steps += 1;
        return steps;
    };

    const [totalSteps] = useState(initialTotalSteps);

    // Fetch all plants and locations for the combo boxes
useEffect(() => {
  const fetchPlants = async () => {
    try {
      console.log('about to call the plant route');
      const response = await api.get('/plants/all');

      const contentType = response.headers['content-type'];
      if (!contentType || !contentType.includes('application/json')) {
        throw new TypeError(`Expected JSON response, but received: ${contentType}`);
      }

      console.log(response.data);
      setPlants(response.data);
    } catch (err) {
      console.error('Error fetching plants:', err);
    }
  };

  const fetchLocations = async () => {
    try {
      console.log('about to call the location route');
      const response = await api.get('/locations/all');
      console.log('About to fill in the location combo box');
      console.log(response.data);
      setLocations(response.data);
    } catch (err) {
      console.error('Error fetching locations:', err);
    }
  };

  fetchPlants();
  fetchLocations();
}, []);

useEffect(() => {
    if (hasFinishedLoading) {
      // skipping seasonal planner for onboarding users because too many were left in onboarding mode
    //console.log('Switching to Season Planner tab...');
    //  handleTabChange('Season Planner', true);
        handleTabChange('Home', true);

    setHasFinishedLoading(false); // reset so it doesn�t trigger again
  }
}, [hasFinishedLoading]);

    useEffect(() => {
        if (step === 4) {

            // Browser does not support install (apple only instructions)
            const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
            const noInstallPrompt = !deferredPrompt || isIOS;
            console.log("STEP 4 new constants isIOS and noInstallPrompt", { isIOS, noInstallPrompt });
            if (noInstallPrompt) {
                // skip install step
                setStep(6);
                return
            }

            // User explicitly said NO during onboarding
            if (userInstallChoice === "declined") {
                setStep(6);
                return
            }


        }

        if (step === 5) {
            // Skip notifications user declined PWA install
            if (userInstallChoice === "declined") {
                setStep(6);
                return;
            }

            // Skip notifications user canceled out of install
            if (browserInstallOutcome === "dismissed") {
                setStep(6);
                return;
            }

            // User accepted install now wait for it to complete
            const isStandalone = 
                window.matchMedia('(display-mode: standalone)').matches || 
                window.navigator.standalone === true; 
                
                if (!isStandalone) { 
                    return; 
                }

            // now safe to evaluate notification permission
            let noPermissionStep = false;
            try {
                noPermissionStep =
                    typeof Notification === 'undefined' ||
                    Notification.permission !== 'default';
            } catch (err) {
                console.warn("Safari iOS Notification.permission threw:", err);
                noPermissionStep = true;
            }

            if (noPermissionStep) {
                setStep(6);
            }
        }
    }, [step, deferredPrompt, userInstallChoice, browserInstallOutcome]);

const fetchCurrentGardener = async () => {
  try {
    console.log('[redacted]: /api/gardeners/current');
    const response = await api.get('/gardeners/current');

    const data = response.data;
    setCurrentGardener(data);
    console.log('the currentgardener locationid:', data.locationID);
    setGardener({ ...data, plant: '', userid: data.id });
    fetchGardenerPlants(data.id); // Fetch gardener plants
    return data;
  } catch (err) {
    if (err.response?.status === 404) {
      setCurrentGardener(null); // No gardener found
    }
    console.error('Error fetching current gardener:', err);
    return null;
  }
};

const fetchGardenerPlants = async (gardenerID) => {
  try {
    const response = await api.get(`/gardenerPlants/${gardenerID}`);
    const data = response.data;
    setUserPlants(data);
  } catch (err) {
    console.error('Error fetching plants:', err);
  }
};

    // Fetch current gardener info and their plants on component mount
    useEffect(() => {
        fetchCurrentGardener();
    }, []);

useEffect(() => {
    if (userPlants.length > 0) {
        setHasAddedPlant(true);
    }
}, [userPlants]);


    const handleChange = (e) => {
        const { name, value } = e.target;

        setGardener((prevGardener) => {
            if (name === 'plantID') {
                const selectedPlant = plants.find((plant) => plant.plantID.toString() === value);
                if (selectedPlant) {
                    console.log(`Selected plant name: ${selectedPlant.name}`);
                    console.log(`Selected plant ID: ${selectedPlant.plantID}`);
                }
            }
            return {
                ...prevGardener,
                [name]: value
            };
        });

        console.log(`${name} changed to ${value}`); // Log changes to verify
    };

const handleResendCode = async () => {
    try {
        await api.post("/gardeners/sendVerificationEmail", { gardenerID: gardener.id, email: gardener.email });
        setVerificationError(""); // clear any previous error
    } catch (err) {
        setVerificationError("Failed to resend code.");
    }
};

const handleSelectJordanCrop = async (e) => {
   e.preventDefault();

    try {

        const { data } = await api.get('/demo/demo-id');
        const demoID = data.demoID;

        // Make an API call to get plants for the specific gardener
        const response = await api.get(`/gardenerPlants/${demoID}`);

        // Check if response is successful
        if (response.status === 200) {
            const demoCrops = response.data; // Assuming backend sends demo crops as an array

            const jordancrop = demoCrops.map(crop => crop.id.toString());
            console.log('jordancrop ', jordancrop);

            //setSelectedPlantIDs(['10', '19'])
            // Update UI to reflect the addition of demo crops
            setSelectedPlantIDs(jordancrop);
            setHasAddedPlant(true); // Set the confirmation message flag
        } else {
            console.error('Failed to fetch demo crops');
        }
    } catch (err) {
        console.error('Error adding demo crops:', err);
    }
};

    const handleConfirmCrops = () => {
  
        if (selectedPlantIDs.length === 0) {
            alert('Please select at least one crop before confirming.');
            return;
        }

        selectedPlantIDs.forEach((plantID) => {
            const plant = plants.find((p) => p.plantID.toString() === plantID);
            handleAddPlant({ plantID, plantType: plant?.type || '' });
        });
        setHasAddedPlant(true);
        setSelectedPlantIDs([]);
    };

const handleSubmit = async (e) => {
  e.preventDefault();

  setIsLoading(true);
  setLoadingMessage("Building your garden plan...");

  try {
    await handleUpdateGardener(gardener);

    const refreshedGardener = await fetchCurrentGardener();
    if (!refreshedGardener) {
      throw new Error('Failed to refresh gardener');
    }

    await api.post('/onboard/runTasks', {
        gardener,
        currentDate
    });

    setIsLoading(false);
    setLoadingMessage("");
    setHasFinishedLoading(true); // now triggers AFTER backend finishes

  } catch (err) {
    setIsLoading(false);
    setLoadingMessage("");
    console.error('Error during onboarding submit:', err);
  }
};

    const handleInstall = async (answer) => {
        // Track the user's onboarding choice
        setWantsInstall(answer);

        if (answer === false) {
            // User explicitly said NO in your onboarding UI
            setUserInstallChoice("declined");   // NEW
            setBrowserInstallOutcome(null);     // No browser prompt happened
            setStep(prev => prev + 1);
            setProgressCount(prev => prev + 1);
            return;
        }

        // If user said YES but there's no browser prompt (iOS or missing prompt)
        if (answer === true && !deferredPrompt) {
            setUserInstallChoice("accepted");   // NEW
            setBrowserInstallOutcome(null);     // No browser prompt available
            setStep(prev => prev + 1);
            setProgressCount(prev => prev + 1);
            return;
        }

        // User said YES and browser prompt exists
        if (answer === true && deferredPrompt) {
            try {
                deferredPrompt.prompt();
                const choiceResult = await deferredPrompt.userChoice;

                // Track Chrome's install outcome
                setBrowserInstallOutcome(choiceResult.outcome); // NEW
                setUserInstallChoice("accepted");               // NEW

                if (choiceResult.outcome === "accepted") {
                    console.log("App installed successfully");
                } else {
                    console.warn("User dismissed install prompt");
                }

                setDeferredPrompt(null);

                setStep(prev => prev + 1);
                setProgressCount(prev => prev + 1);

            } catch (err) {
                console.error("Error during install prompt:", err);
            }
        }
    };

    const handleVerifyCode = async () => {
    try {
        const res = await api.post("/gardeners/verifyEmailCode", {
            gardenerID: gardener.id,
            email: gardener.email,
            code: verificationCode
        });

        if (res.data.success) {
            // Code correct therefore move to Step 3
            setIsVerifyingEmail(false);
            setVerificationError("");
            setStep(3);
            setProgressCount(prev => prev + 1);
        } else {
            setVerificationError("Invalid or expired code.");
        }
    } catch (err) {
        setVerificationError("Verification failed. Try again.");
    }
};


    // GardenerOnboard.js
    const handleSeasonalAdvice = async (answer) => {
        setWantsSeasonalAdvice(answer);

        if (answer) {
            try {
                if (!('Notification' in window)) {
                    console.warn('Notifications not supported in this browser.');
                } else {

                    // Show spinner/message
                    setIsRequestingPermission(true);

                    const permission = await Notification.requestPermission(); // must be called from this user action
                    console.log('Notification permission result:', permission);

                    // Hide spinner/message
                    setIsRequestingPermission(false);

                    if (permission === 'granted') {
                        if (!VAPID_PUBLIC_KEY || !currentGardener?.id) {
                            console.warn('Missing VAPID key or gardener ID � cannot subscribe to push.');
                        } else {
                            const sub = await subscribeUserToPush(currentGardener.id, VAPID_PUBLIC_KEY);
                            if (!sub) console.warn('Subscription failed or not supported.');
                        }
                    } else {
                        console.warn('User denied notification permission.');
                    }
                }
            } catch (err) {
                console.error('Error during notification setup:', err);
            }
        }

        // Always advance to the next step after handling the answer
        setStep(prev => prev + 1);
        setProgressCount(prev => prev + 1);
    };

    const handleMultiSelect = (e) => {
        const options = Array.from(e.target.selectedOptions);
        const values = options.map((opt) => opt.value);
        setSelectedPlantIDs(values);
    };

const nextStep = async (e) => {
  e.preventDefault();

  let missingMessage = '';

  if (step === 1 && !gardener.name) {
    missingMessage = 'We use your name to personalize your garden plan.';
  } else if (step === 2 && !isVerifyingEmail) {
        if (!gardener.email) {
            missingMessage = 'We use your email to recover your forgotten password and to send the generated report.';
        } else {
            try {
                // EMAIL UNIQUENESS CHECK
                await api.post("/gardeners/check-email", { email: gardener.email });

            } catch (err) {
                missingMessage = 'This email is already used by another gardener.';
            }

            if(!missingMessage) { 

                setIsVerifyingEmail(true);

                try {
                    //Send verification code
                    await api.post("/gardeners/sendVerificationEmail", {gardnerID: gardener.id, email: gardener.email });

                } catch (err) {
                    missingMessage = 'This is not a valid email.';
                    setIsVerifyingEmail(false);

                }
                if (!missingMessage) {
                    return;
                    }
            }
        }
  } else if (step === 3 && !gardener.locationID) {
      missingMessage = 'We use your location to determine your closest weatherstation.';
  } else if (step === 4 && wantsInstall === null) {
      missingMessage = 'This helps us know if you want to install the app.';
  } else if (step === 5 && wantsSeasonalAdvice === null) {
      missingMessage = 'This helps us know if you want seasonal nudges and reminders.';
  } else if (step === 6 && !gardener.experienceLevel) {
    missingMessage = 'Your experience level helps us tailor the guidance we give.';
    } else if (step === 7) {
        const size = Number(gardener.familysize);

        if (!size) {
            missingMessage = 'We use family size to calculate how much to plant.';
        } else if (size < 1 || size > 12) {
            missingMessage = 'Family size must be between 1 and 12.';
        } else {
            await fetchCurrentGardener();
        }
    }

  if (missingMessage) {
    alert(missingMessage);
    return;
    }

    // Persist gardener update after each step
  try {
      await handleUpdateGardener(gardener);

      await fetchCurrentGardener();

  } catch (err) {
    console.error('Failed to update gardener during onboarding step:', err);
  }

    setStep((prev) => prev + 1);
    setProgressCount(prev => prev + 1);
};

const prevStep = () => {
  let missingMessage = '';

  if (step === 2 && !gardener.name) {
    missingMessage = 'Please enter your name before going back.';
  } else if (step === 3 && !gardener.email) {
    missingMessage = 'Please enter your email before going back.';
  } else if (step === 4 && !gardener.locationID) {
    missingMessage = 'Please select your location before going back.';
  } else if (step === 6 && !gardener.experienceLevel) {
    missingMessage = 'Please choose your experience level before going back.';
  } else if (step === 7 && !gardener.familysize) {
    missingMessage = 'Please enter your family size before going back.';
  }

  if (missingMessage) {
    alert(missingMessage);
    return; // stop here � do NOT decrement progress
  }

  // Only runs if the step is valid
  setStep(prev => prev - 1);
  setProgressCount(prev => Math.max(prev - 1, 0));
};

return (
    <div className="add-gardener-form-container">
        <div className="add-gardener-form">
            <h1 className="onboarding-heading">GrowYourFoodApp Onboarding</h1>
            <p className="onboarding-subheading">
                Let's personalize your garden plan - step by step.
            </p>
            <div className="progress-tracker">
                <div className="progress-bar" >
                    <div className="progress-fill" style={{ width: `${(progressCount / totalSteps) * 100}%` }} />
                </div>
                <p className="progress-text">
                    Completed {progressCount} of {totalSteps}
                </p>
            </div>
            {step === 2 && isVerifyingEmail && (
                    <div>
                        <p>We sent a 6-digit code to <strong>{gardener.email}</strong></p>

                        <input
                            type="text"
                            maxLength="6"
                            value={verificationCode}
                            onChange={(e) => setVerificationCode(e.target.value)}
                            autoFocus
                        />

                        {verificationError && <p className="error">{verificationError}</p>}

                        <button
                            type="button"
                            className="button"
                            onClick={handleVerifyCode}
                        >
                            Verify Email
                        </button>

                        <button
                            type="button"
                            className="button secondary"
                            onClick={handleResendCode}
                        >
                            Resend Code
                        </button>

                        <button
                            type="button"
                            className="button tertiary"
                            onClick={() => {
                                setIsVerifyingEmail(false);
                                setVerificationCode("");
                                setVerificationError("");
                            }}
                        >
                            Change Email
                        </button>
                    </div>
            )}

            <form id="gardener-form" onSubmit={(e) => e.preventDefault()}>

                {step === 1 && (
                    <div>
                        <label>What should I call you?:</label>
                        <input 
                            name="name"
                            value={gardener.name} 
                            onChange={handleChange} 
                            required
                            autoFocus
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault(); // prevent form submission
                                     nextStep(e);         // trigger next step
                                }
                            }}
                        />
                        <button type="button" className="button" onClick={nextStep}>Next</button>
                    </div>
                )}

                {step === 2 && !isVerifyingEmail && (
                    <div>
                        <label>What is your email?:</label>
                        <input
                            type="email"
                            name="email"
                            value={gardener.email}
                            onChange={handleChange}
                            required
                            autoFocus
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    nextStep(e);
                                }
                            }}
                        />
                        <button type="button" className="button" onClick={nextStep}>Next</button>
                    </div>
                )}


                {step === 3 && (
                    <div>
                        <label>Where are you growing?:</label>
                        <select name="locationID" value={gardener.locationID} onChange={handleLocationChange} required autoFocus onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault(); // prevent form submission
                                nextStep(e);         // trigger next step
                            }
                        }}
>
                            <option value="">Select your location</option>
                            {locations.map((loc) => (
                                <option key={loc.id} value={loc.id}>
                                    {loc.city}, {loc.province}, {loc.country}
                                </option>
                            ))}

                        </select>
                        <div className="location-display">
                            {gardener.city}, {gardener.province}, {gardener.country}
                        </div>
                        <button type="button" className="button" onClick={nextStep}>Next</button>
                    </div>
                )}

                {isRequestingPermission && (
                    <div className="permission-overlay">
                        <div className="spinner"></div>
                        <p>One moment - your browser will ask for permission...</p>
                    </div>
                )}

                {step === 4 && (
                  deferredPrompt ? (
                    <div>
                        <label>Would you like to add GrowYourFood to your device?</label>
                        <p className="helper-text">
                            Adding GrowYourFood makes it easy to open like any other app.  You will see it on your home screen or taskbar.
                        </p>
                        <select
                            name="installApp"
                            value={wantsInstall ?? ''}
                            onChange={(e) => handleInstall(e.target.value === 'true')}
                            required
                            autoFocus
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault(); // prevent form submission
                                    nextStep(e);         // trigger next step
                                }
                            }}
                        >
                            <option value="">Select an option</option>
                            <option value="true">Yes, install GrowYourFood</option>
                            <option value="false">No, continue without installing</option>
                        </select>
                        </div>
                    ) : (<div className="placeholder-step" /> )
                )}

                {step === 5 && (
                  typeof Notification !== 'undefined' && Notification.permission !== 'denied' ? (
                    <div>
                        <label>Would you like helpful reminders to guide your growing?</label>
                        <p className="helper-text">
                            If you allow reminders, GrowYourFood will send gentle tips when it is time to plant or harvest.  You can turn these off anytime.
                        </p>
                        <select
                            name="seasonalAdvice"
                            value={wantsSeasonalAdvice ?? ''}
                            onChange={(e) => handleSeasonalAdvice(e.target.value === 'true')}
                            required
                            autoFocus
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault(); // prevent form submission
                                    nextStep(e);         // trigger next step
                                }
                            }}
                        >
                            <option value="">Select an option</option>
                            <option value="true">Yes, send me reminders</option>
                            <option value="false">No, continue without reminders</option>
                        </select>

                        </div>
                    ) : (<div className="placeholder-step" /> )
                )}

                {step === 6 && (
                    <div>
                        <label>What is your gardening experience?</label>
                        <select
                            name="experienceLevel"
                            value={gardener.experienceLevel}
                            onChange={handleChange}
                            required
                            autoFocus
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault(); // prevent form submission
                                    nextStep(e);         // trigger next step
                                }
                            }}

                        >
                            <option value="">Select your level</option>
                            <option value="Beginner">Beginner</option>
                            <option value="Intermediate">Intermediate</option>
                            <option value="Seasoned">Seasoned</option>
                        </select>

                        <button type="button" className="button" onClick={nextStep}>Next</button>
                    </div>
                )}

                {step === 7 && (
                    <div>
                        <label>How many people will you be feeding?</label>
                        <input
                            name="familysize"
                            type="number"
                            value={gardener.familysize}
                            onChange={handleChange}
                            required
                            autoFocus
                            min="1"
                            max="12"
                            onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault(); // prevent form submission
                                nextStep(e);         // trigger next step
                            }
                        }}
/>
                        <button type="button" className="button" onClick={nextStep}>Next</button>
                    </div>
                )}

                {step === 8 && (
                    <div>
                        <label>Select the crops you plan on growing:</label>
                        <p className="helper-text">
                             Hold down <strong>Ctrl</strong> (or <strong>Cmd</strong> on Mac) to select multiple crops.
                        </p>


                        {/* Display a button for copying Jordan's crops for beginners and intermediates */}
                        {(currentGardener?.experienceLevel === 'Beginner' || currentGardener?.experienceLevel === 'Intermediate') && (
                            <div className="copy-jordan-section">
                                <button
                                    type="button"
                                    className="button"
                                    onClick={handleSelectJordanCrop }
                                >
                                    Copy Jordan's Crops
                                </button>
                                <p className="helper-text">
                                    {currentGardener?.experienceLevel === 'Beginner' &&
                                        "Not sure where to start, Jordan is a year-round gardener - these crops can be grown across all seasons."}
                                    {currentGardener?.experienceLevel === 'Intermediate' &&
                                        "Not sure how to achieve year-round gardening, Jordan is a year-round gardener."}
                                </p>
                            </div>
                        )}

                        {/* Crop selection dropdown */}
                        <select
                            name="plantID"
                            multiple
                            value={selectedPlantIDs}
                            onChange={handleMultiSelect}
                        >
                            {plants.map((plant) => (
                                <option key={plant.plantID} value={plant.plantID}>
                                    {plant.name}
                                </option>
                            ))}
                        </select>

                        <div className="selected-plants-preview">
                            <p>You are planning to grow:</p>
                            <ul>
                                {selectedPlantIDs.map((id) => {
                                    const plant = plants.find((p) => p.plantID.toString() === id);
                                    return <li key={id}>{plant?.name}</li>;
                                })}
                            </ul>
                        </div>

                        <button type="button" className="button" onClick={handleConfirmCrops}>
                            Confirm Crop Selection
                        </button>

                        {hasAddedPlant && (
                            <p className="confirmation-message">Crops have been added to your Current Crops list.</p>
                        )}

                        {hasAddedPlant && (
                            <button
                                type="submit"
                                className="button"
                                onClick={handleSubmit}
                            >
                                Finish Setup
                            </button>
                        )}
                        {isLoading && (
                        <div className="inline-progress-bar">
                            <div className="bar">
                                <div className="fill" />
                            </div>
                             <p>{loadingMessage}</p>
                        </div>
                        )}

                    </div>
                )}
            </form>
        </div>
    </div>
);
};

export default GardenerOnboard;
